import request from './request'

export function listConsultTickets(params) {
  return request.get('/biz/consult-tickets', { params })
}
export function getConsultTicket(id) {
  return request.get(`/biz/consult-tickets/${id}`)
}
export function createConsultTicket(data) {
  return request.post('/biz/consult-tickets', data)
}
export function deleteConsultTicket(id) {
  return request.delete(`/biz/consult-tickets/${id}`)
}
export function replyConsultTicket(id, data) {
  return request.post(`/biz/consult-tickets/${id}/reply`, data)
}
export function closeConsultTicket(id) {
  return request.post(`/biz/consult-tickets/${id}/close`)
}
export function listConsultIssueTypes() {
  return request.get('/biz/consult-tickets/issue-types')
}

export function listOpsConsultTickets(params) {
  return request.get('/ops/consult-tickets', { params })
}
export function getOpsConsultTicket(id) {
  return request.get(`/ops/consult-tickets/${id}`)
}
export function replyOpsConsultTicket(id, data) {
  return request.post(`/ops/consult-tickets/${id}/reply`, data)
}
export function closeOpsConsultTicket(id) {
  return request.post(`/ops/consult-tickets/${id}/close`)
}
